export enum Environment {
  TEST = 'TEST',
  PROD = 'PROD'
}
